module.exports = __webpack_public_path__ + "static/media/kanero-logo-with-name.c952b83f.png";